<template>
    <div>
        <div class="d-flex flex-wrap justify-content-end">
            <span style="font-size: 0.8rem;" class="text-right align-self-end mb-2"
                >* tv- and online-data are components for calculation of the total, not exactly the same as the values for tv and online video.</span
            >
        </div>
        <b-table
            thead-class="stickyfancytableheader"
            class="tablemainresultclass"
            :items="tableRows"
            :fields="visibleColumns"
            primary-key="index"
            :head-variant="'dark'"
            bordered
            small
            striped
            :per-page="visibleRows"
            :current-page="currentPage"
            @sort-changed="sortingChanged"
            show-empty
            :empty-text="noRowsText"
            :sort-by="sortBy"
            :sort-desc="sortDesc"
        >
            <template v-slot:top-row>
                <td class="summary-row" v-for="field in visibleColumns" :key="field.key" :class="field.tdClass">
                    {{ tableTotalRow[field.key] }}
                </td>
            </template>
            <template v-slot:head()="field">
                <span class="measureheader" v-html="getTableFieldLabel(field)"></span>
            </template>
            <template v-slot:cell(providerName)="row">
                <span v-html="row.item.providerNameVhtml" v-if="row.item.providerNameVhtml"></span>
                <span v-else>{{ row.item.providerName }}</span>
            </template>
        </b-table>
        <b-pagination v-if="tableRows.length + 1 > visibleRows" class="justify-content-center" v-model="currentPage" :total-rows="tableRows.length + 1" :per-page="visibleRows"></b-pagination>
    </div>
</template>

<script>
export default {
    name: "ReportAdTable",
    data() {
        return {
            currentPage: 1,
            visibleRows: 50,
            sortBy: null,
            sortDesc: true,
        }
    },
    props: {
        measureTypeSelected: {
            type: String,
        },
    },
    watch: {
        adsCampaignReportMeasureSumMode() {
            this.setDefaultSorting()
        },
    },
    mounted() {
        this.setDefaultSorting()
    },
    computed: {
        adsCampaignReportMeasureSumMode() {
            return this.$store.getters.getAdsCampaignReportMeasureSumMode
        },
        visibleColumns() {
            const sumModeKey = this.$store.getters.getAdsCampaignReportMeasureSumMode.key
            if (this.$store.getters.getAdsCampaignReportResults.data[sumModeKey].status === "LOADED") {
                // Ensuring all columns are marked as sortable
                return this.$store.getters.getAdsCampaignReportResults.data[sumModeKey].viewTypeColumns.concat(this.tableMeasures).map(col => ({ ...col, sortable: true }))
            } else {
                return []
            }
        },
        tableRows() {
            return this.$store.getters.getAdsCampaignReportResults.data[this.$store.getters.getAdsCampaignReportMeasureSumMode.key]?.levelOneAdsWithLevelTwoAds ?? []
        },
        tableTotalRow() {
            let summaryRow = this.$store.getters.getAdsCampaignReportResults.data[this.$store.getters.getAdsCampaignReportMeasureSumMode.key]?.totalRow
            let firstColumn = this.visibleColumns[0].key
            summaryRow[firstColumn] = "CALCULATION"
            return summaryRow
        },
        tableMeasures() {
            return this.$store.getters.getAdsCampaignReportResults.data.measureColumns.filter(m => m.subHeader.includes(this.$store.getters.getAdsCampaignReportCurrentTargetGroup))
        },
        noRowsText() {
            return "No result to display"
        },
    },
    methods: {
        lastColumnKey() {
            if (this.measureTypeSelected === "absolute_reach") {
                const lastColumn = this.visibleColumns[this.visibleColumns.length - 1]
                this.sortBy = lastColumn ? lastColumn.key : null
                return this.sortBy
            } else return this.sortBy
        },
        sortingChanged(ctx) {
            if (ctx.sortBy) {
                this.sortBy = ctx.sortBy
                this.sortDesc = ctx.sortDesc
            }
        },
        getTableFieldLabel(field) {
            if (!field.field.key.includes("measure")) {
                return field.field.label
            }
            const subHeader = field.field.subHeader
            const regexPatterns = [
                { regex: /\(tv-data\)/, source: "(tv-data)*" },
                { regex: /\(online-data\)/, source: "(online-data)*" },
                { regex: /TV/, source: "(tv-data)*" },
                { regex: /Online/, source: "(online-data)*" },
                { regex: /Total/, source: "Total" },
            ]
            for (const { regex, source } of regexPatterns) {
                if (regex.test(subHeader)) {
                    field.field.targetGroupHeader = subHeader.replace(regex, "")
                    field.field.sourceHeader = source
                    return `${field.field.header} <span class="measureagewrapper">${field.field.targetGroupHeader}</span><span class="measureagewrapper">${field.field.sourceHeader}</span>`
                }
            }
            // Default case if none of the patterns match
            field.field.targetGroupHeader = subHeader
            field.field.sourceHeader = ""
            return `${field.field.header} <span class="measureagewrapper">${field.field.targetGroupHeader}</span><span class="measureagewrapper">${field.field.sourceHeader}</span>`
        },
        setDefaultSorting() {
            const sumModeKey = this.$store.getters.getAdsCampaignReportMeasureSumMode.key
            let sortKey
            let desc = true
            switch (sumModeKey) {
                case "PROVIDER":
                case "FILMCODE":
                    sortKey = this.lastColumnKey()
                    desc = true
                    break
                case "DAY":
                    sortKey = "date"
                    desc = false
                    break
                case "WEEK":
                    sortKey = "yearWeek"
                    desc = false
                    break
                default:
                    sortKey = this.lastColumnKey()
            }
            this.sortingChanged({
                sortBy: sortKey,
                sortDesc: desc,
            })
        },
    },
}
</script>

<style scoped>
table.tablemainresultclass {
    min-width: 600px;
}
::v-deep .summary-row {
    background-color: #ddd !important;
    font-weight: bold;
    border-bottom: 5px solid #737c84;
}
::v-deep .tablemainresultclass th {
    font-size: 0.8rem;
    background-color: #337ab7 !important;
    border-color: #bfd5e8 !important;
    border-top: white;
    border-width: 2px 1px 2px 1px !important;
    vertical-align: middle;
    padding-top: 0;
    padding-bottom: 0;
}
::v-deep .tablemainresultclass th.measurethclass {
    width: 10rem !important;
}
::v-deep tbody tr td {
    border-bottom: none;
    border-top: 1px solid #dee2e6;
    border-left: 1px solid #dee2e6;
    border-right: 1px solid #dee2e6;
}

::v-deep .titleheadercolumn {
    width: 10%;
}
</style>
